import './InstructionPopUp.css'
import React from "react"

function InstructionPopUp(props) {

    return (
        <div style={{"position": "absolute", "marginTop": props.marginTop, "marginLeft": props.marginLeft}}>
        <div className="instructionPopUp">
            <p className="closePopUp" onClick={()=> props.setShowPopUp(false)}> x </p>
            <p class> {props.text} </p>
        </div>
        </div>

    )
}

export default InstructionPopUp;